import Component from '@glimmer/component';
import type { FillColorString } from 'garaje/components/ui-pill';
import UiPill from 'garaje/components/ui-pill';

export type DocumentStatus = 'review' | 'approved' | 'denied' | 'not-uploaded';

interface Signature {
  Args: {
    status: DocumentStatus;
  };
  Element: HTMLSpanElement;
}

const STATUS_MAP: Record<DocumentStatus, { text: string; fill: FillColorString }> = {
  review: { text: 'PENDING APPROVAL', fill: 'orangeLightest' },
  approved: { text: 'APPROVED', fill: 'greenLightest' },
  denied: { text: 'DENIED', fill: 'redLighter' },
  'not-uploaded': { text: 'NOT UPLOADED', fill: 'grayLighter' },
};

export default class DocumentStatusBadge extends Component<Signature> {
  get config(): { text: string; fill: FillColorString } {
    return STATUS_MAP[this.args.status] ?? STATUS_MAP['not-uploaded'];
  }

  <template>
    <UiPill @fill={{this.config.fill}} @size="small" data-test-document-status-badge ...attributes>
      {{this.config.text}}
    </UiPill>
  </template>
}
